import { SeasonSelector } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrappedTeamCompetitionAverageSeasonOptionsAtom } from '@/atoms/filters/team/teamCompetitionAverageFilters';
import { CompetitionAverageFilterPanel } from '@/components/filters/CompetitionAverageFilterPanel';
import { UserCompetitionSelect } from '@/components/filters/UserCompetitionSelect';
import { usePhysicalMetricsFeature } from '@/hooks/featureFlags';

export const TeamCompetitionAveragePanel = () => {
  const seasonOptions = useAtomValue(unwrappedTeamCompetitionAverageSeasonOptionsAtom);
  const physicalMetricsEnabled = usePhysicalMetricsFeature();

  return (
    <CompetitionAverageFilterPanel>
      <UserCompetitionSelect showTracking={physicalMetricsEnabled} />
      <SeasonSelector options={seasonOptions} isMulti />
    </CompetitionAverageFilterPanel>
  );
};
